import { MenuItems } from '../types';
import Divider from './Divider';
import MenuItem from './MenuItem';

type MenuContentProps = {
  items: MenuItems;
  numPlayers: number;
};

function MenuContent({ items, numPlayers }: MenuContentProps) {
  return (
    <div>
      {items.main.map((item) => (
        <MenuItem key={item.title} item={item} numPlayers={numPlayers} />
      ))}
      {items.additional && <Divider />}
      {items.additional?.map((item) => (
        <MenuItem key={item.title} item={item} numPlayers={numPlayers} />
      ))}
    </div>
  );
}

export default MenuContent;
